import { Component, signal } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { AppService } from './services/app/app.service';
import { filter, map } from 'rxjs/operators';
import { Router, RoutesRecognized } from '@angular/router';
import { Observable, take } from 'rxjs';
import { MenuItem } from '@rs-shared-lib/models/top-bar-menu-items';
import { BRAND_NAMES } from '@lib/rs-ngx';

@Component({
  selector: 'mgt-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false
})
export class AppComponent {
  public readonly shouldShowTopBar$: Observable<boolean>;
  public readonly menuItems = signal<Array<MenuItem>>([]);

  public constructor(
    private readonly titleService: Title,
    private readonly appService: AppService,
    private readonly router: Router,
  ) {
    this.shouldShowTopBar$ = this.router.events.pipe(
      filter(event => event instanceof RoutesRecognized),
      map(event => {
        const hideTopBar = (event as RoutesRecognized).state.root.firstChild?.data.hideTopBar ?? false;
        return !hideTopBar;
      }),
      take(1)
    );

    this.appService
      .mappedUserAccesses()
      .pipe( map((accesses): MenuItem[] => ([
        {
          url: '/users',
          id: 'users',
          label: 'USERS',
          display: accesses.users,
        },
        {
          id: 'company',
          url: '/company',
          label: 'COMPANY',
          display: accesses.company,
        },
        {
          id: 'pricing',
          url: '/pricing',
          label: 'PRICING',
          display: accesses.pricing,
        },
        {
          id: 'insights',
          label: 'INSIGHTS.INSIGHTS',
          display: Boolean(Object.keys(accesses.insights).length),
          subMenuItems: accesses.insights
            .map(
              (group) => ({
                id: group.name,
                url: `/insights/${group.name}/${group.id}`,
                label: group.name,
                doNotTranslateLabel: true,
              })
            )
        }
      ])))
      .subscribe({
        next: (menuItems) => this.menuItems.set(menuItems)
      });
  }

  public ngOnInit(): void {
    this.titleService.setTitle(BRAND_NAMES['MGT']);
  }
}
